import { useI18n } from 'hooks/useI18n';
import Rotation from './Rotation';
import Satisfaction from './Satisfaction';
import {
  StyledBillboard,
  StyledBillboardContent,
  StyledBillboardTitle,
  StyledContainer
} from './SuccessRate.styled';
import SuccessRateData from './SuccessRateData';

const SuccessRate: React.FC = () => {
  const { t } = useI18n('state-of-hiring');

  return (
    <div>
      <StyledBillboard>
        <StyledContainer>
          <StyledBillboardContent>
            <StyledBillboardTitle as="p">
              {t('state-of-hiring.success-rate.billboard-title')}
            </StyledBillboardTitle>
            <p>{t('state-of-hiring.success-rate.billboard-desc')}</p>
          </StyledBillboardContent>
        </StyledContainer>
      </StyledBillboard>
      <SuccessRateData />
      <Satisfaction />
      <Rotation />
    </div>
  );
};

export default SuccessRate;
